import { render, staticRenderFns } from "./PrestacionSaludProgramas.vue?vue&type=template&id=5236ae4d&scoped=true"
import script from "./PrestacionSaludProgramas.vue?vue&type=script&lang=ts"
export * from "./PrestacionSaludProgramas.vue?vue&type=script&lang=ts"
import style0 from "./PrestacionSaludProgramas.vue?vue&type=style&index=0&id=5236ae4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5236ae4d",
  null
  
)

export default component.exports